import React from 'react';
import { AiHeader } from './AiHeader';
import { AiFooter } from './AiFooter';

interface AiLayoutProps {
  children: React.ReactNode;
}

/**
 * Shell for all .ai public pages. The outer wrapper carries `.ai-page`
 * (Pitfall 6 — fixed per checker B3). The `.ai-page` rule in ai.css holds
 * the dark background + text-color baseline; admin/auth/blog routes use
 * the legacy <Layout> and therefore do NOT receive the .ai-page wrapper,
 * so they keep light backgrounds on the .ai domain.
 */
export const AiLayout: React.FC<AiLayoutProps> = ({ children }) => {
  return (
    <div className="ai-page">
      <AiHeader />
      <main className="ai-main">
        {children}
      </main>
      <AiFooter />
    </div>
  );
};

export default AiLayout;
